(() => {
  const carouselSelector = 'effect-carousel, media-carousel, announcement-bar, [data-p5-slider]';
  let pointerGesture = null;
  let touchGesture = null;

  const carouselFor = target => target instanceof Element ? target.closest(carouselSelector) : null;

  window.addEventListener('pointerdown', event => {
    const carousel = carouselFor(event.target);
    pointerGesture = carousel ? { carousel, x: event.clientX, y: event.clientY } : null;
  }, true);

  window.addEventListener('pointermove', event => {
    if (!pointerGesture || !pointerGesture.carousel.isConnected) return;
    const deltaX = Math.abs(event.clientX - pointerGesture.x);
    const deltaY = Math.abs(event.clientY - pointerGesture.y);
    if (deltaY > 6 && deltaY > deltaX) event.stopImmediatePropagation();
  }, { capture: true, passive: true });

  const clearPointer = () => { pointerGesture = null; };
  window.addEventListener('pointerup', clearPointer, true);
  window.addEventListener('pointercancel', clearPointer, true);

  window.addEventListener('touchstart', event => {
    const carousel = carouselFor(event.target);
    const touch = event.touches[0];
    touchGesture = carousel && touch ? { carousel, x: touch.clientX, y: touch.clientY } : null;
  }, { capture: true, passive: true });

  window.addEventListener('touchmove', event => {
    const touch = event.touches[0];
    if (!touchGesture || !touch || !touchGesture.carousel.isConnected) return;
    const deltaX = Math.abs(touch.clientX - touchGesture.x);
    const deltaY = Math.abs(touch.clientY - touchGesture.y);
    if (deltaY > 6 && deltaY > deltaX) event.stopImmediatePropagation();
  }, { capture: true, passive: true });

  window.addEventListener('touchend', () => { touchGesture = null; }, true);
  window.addEventListener('touchcancel', () => { touchGesture = null; }, true);
})();

